import * as React from 'react';
import styled from 'styled-components';

const Container = styled.div`
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  background-color: ${(props) => props.theme.pallet.primary};
  color: #fff;

  .sky-line {
    position: absolute;
    bottom: 0;
    width: 100%;
    opacity: .10;
  }

  span {
    display: flex;
    align-items: center;

    h1 {
      font-size: 1.8rem;
      margin-left: 8px;
    }
  }
`;

export default () => (
  <Container>
    <img
      src='/assets/new-york-skyline-clean.png'
      alt='New York Skyline Outline'
      className="sky-line"
    />    

    <span>
      <img
        width='40'
        height='40'
        src='/assets/spectacles-logo-white.png'
        alt='Spectacles Logo'
      />
      <h1>Spectacles</h1>
    </span>
    <p>Application Initializing...</p>
  </Container>
);